<div class="ni-generateform-popup-content">
    <div class="cmn-modal-header">
        <h4 class="modal-header-title"> Generate Form 484A1 </h4>
    </div>
    <div class="cmn-modal-content" [ngClass]="{'popupScrollDisable':isPopupScrollLock}">
        <!-- generate form screen 1 -->
        <div class="generateform-content" *ngIf="isFirstScreenVisible">
            <p class="generateform-content-paragrph">You have changed the address to "<span class="generateform-content-address">{{ newPhyAddressLine }}"</span></p>
            <p class="generateform-content-paragrph">Generate Form 484A1 to update this address in NowInfinity.</p>
            <p class="generateform-content-paragrph">The following clients are affected by this address change:</p>
            <ul *ngIf="sourceComponent === 'contactComponent'" class="generateform-content-clntcontctlist">
                <li *ngFor="let item of clientData; let i = index">
                    <div class="cmn-checkbox wth-default-template-lg">
                        <input [id]="'checkbox' + i" type="checkbox" [(ngModel)]="item.isChecked" (change)="onCheckboxChange(item)"/>
                        <label class="cmn-checkbox-text" [for]="'checkbox' + i">
                            <span class="checkbox-square"></span>
                            {{ item.relationName }} ({{ transformRole(item.role) }})
                        </label>
                    </div>
                </li>
            </ul>
            <ul *ngIf="sourceComponent === 'createContactComponent'" class="generateform-content-clntcontctlist">
                <li *ngFor="let item of contactData; let i = index">
                    <div class="cmn-checkbox wth-default-template-lg">
                        <input [id]="'checkbox' + i" type="checkbox" [(ngModel)]="item.isChecked" (change)="onCheckboxChange(item)"/>
                        <label class="cmn-checkbox-text" [for]="'checkbox' + i">
                            <span class="checkbox-square"></span>
                            {{ item.relationName }} ({{ transformRole(item.role) }})
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <!-- generate form screen 1 end -->
        <!-- generate form screen 2 -->
        <div class="generateform-content" *ngIf="isSecondScreenVisible">
            <p class="generateform-content-paragrph">Forms will be generated for these clients:</p>
            <div class="generateform-content-entityContent">                
                <div class="entity-table-content cmn-table-design">
                    <table class="table table-borderless">
                        <thead>
                            <tr>
                                <th class="entityname-table-firstcell">Entity</th>
                                <th>Effective date<span class="error-text">*</span></th>
                                <th>Authorising officeholder<span class="error-text">*</span></th>
                                <th>Other address update</th>
                                <th>Signing manager<span class="error-text">*</span></th>
                            </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngIf="sourceComponent === 'contactComponent'; else contactRows">
                            <tr *ngFor="let item of selectedEntitiesForSecondScreen">
                                <td class="entityname-table-firstcell">
                                    <div class="entityname-text" [title]="item.relationName">{{ item.relationName }}</div>
                                </td>
                                <td>
                                    <div class="form-datepicker-container cmn-material-datepicker">
                                        <mat-form-field floatLabel="never" appearance="standard">
                                            <input class="cmn-mat-dtpicker-input" matInput [(ngModel)]="item.effectiveDate"
                                                [matDatepicker]="effectiveDateDtpkr" autocomplete="off" placeholder="dd/mm/yyyy">
                                            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                                [for]="effectiveDateDtpkr"></mat-datepicker-toggle>
                                            <mat-datepicker panelClass="cmn-datepicker-ui" #effectiveDateDtpkr></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-select-container">
                                        <ng-select [items]="authorisorList" class="cmn-ngselect authorisor-drpdwn" bindLabel="authorisorName"
                                            bindValue="authorisorId" [clearable]="false" appendTo="body" [(ngModel)]="item.authorizedUser"
                                            (open)="popupScrollLock()" (close)="removepopupScrollLock()" placeholder="Select authorisor">
                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                <div class="cmn-ngselect-role-tmplt">
                                                    <div class="role-item-nametext" title="{{item.authorisorName}}">
                                                        {{item.authorisorName.length > 15 ? (item.authorisorName|
                                                        slice:0:15) + '..' : item.authorisorName}}</div>
                                                    <p class="role-value-text" title="{{item.authorisorRole}}">
                                                        <img src="../../../../assets/img/role-ic.svg" alt="icon" />
                                                        {{item.authorisorRole}}
                                                    </p>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-multiselect-container">
                                        <ng-multiselect-dropdown class="cmn-multiselect-dropdown ellipsis-itemname"
                                            [(ngModel)]="item.addressType" [placeholder]="'None'" [settings]="addressTypeConfig"
                                            [data]="addressTypeList">
                                        </ng-multiselect-dropdown>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-input-container">
                                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="item.signingManagerUsername"
                                            placeholder="Enter email" />
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #contactRows>
                            <tr *ngFor="let item of selectedEntitiesForSecondScreen">
                                <td class="entityname-table-firstcell">
                                    <div class="entityname-text" [title]="item.relationName">{{ item.relationName }}</div>
                                </td>
                                <td>
                                    <div class="form-datepicker-container cmn-material-datepicker">
                                        <mat-form-field floatLabel="never" appearance="standard">
                                            <input class="cmn-mat-dtpicker-input" matInput [(ngModel)]="item.effectiveDate"
                                                [matDatepicker]="effectiveDateDtpkr" autocomplete="off" placeholder="dd/mm/yyyy">
                                            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                                [for]="effectiveDateDtpkr"></mat-datepicker-toggle>
                                            <mat-datepicker panelClass="cmn-datepicker-ui" #effectiveDateDtpkr></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-select-container">
                                        <ng-select [items]="authorisorList" class="cmn-ngselect authorisor-drpdwn" bindLabel="authorisorName"
                                            bindValue="authorisorId" [clearable]="false" appendTo="body" [(ngModel)]="item.authorizedUser"
                                            (open)="popupScrollLock()" (close)="removepopupScrollLock()" placeholder="Select authorisor">
                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                <div class="cmn-ngselect-role-tmplt">
                                                    <div class="role-item-nametext" title="{{item.authorisorName}}">
                                                        {{item.authorisorName.length > 15 ? (item.authorisorName|
                                                        slice:0:15) + '..' : item.authorisorName}}</div>
                                                    <p class="role-value-text" title="{{item.authorisorRole}}">
                                                        <img src="../../../../assets/img/role-ic.svg" alt="icon" />
                                                        {{item.authorisorRole}}
                                                    </p>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-multiselect-container">
                                        <ng-multiselect-dropdown class="cmn-multiselect-dropdown ellipsis-itemname"
                                            [(ngModel)]="item.addressType" [placeholder]="'None'" [settings]="addressTypeConfig"
                                            [data]="addressTypeList">
                                        </ng-multiselect-dropdown>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-input-container">
                                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="item.signingManagerUsername"
                                            placeholder="Enter email" />
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- generate form screen 2 end -->
    </div>
    <div class="cmn-modal-footer"> 
        <button type="button" mat-button class="cmn-blue-btn" (click)="handleYesClick()"
            *ngIf="isFirstScreenVisible">Yes</button>
        <button type="button" mat-button class="cmn-inverse-btn" (click)="handleNoClick()"
            *ngIf="isFirstScreenVisible">No</button>
        <button type="button" mat-button class="cmn-blue-btn" *ngIf="isSecondScreenVisible" (click)="addEditAddressChangeSubmit()" [disabled]="!isFormValid()">Update</button> 
        <button type="button" mat-button class="cmn-inverse-btn" *ngIf="isSecondScreenVisible" (click)="cancelPopUp()">Cancel</button>
    </div>
</div>